import axios from "@/libs/api.request";

export const getWaitList = data => {
  return axios.request({
    url: "/endpoint/exception/allShelves",
    method: "post",
    data
  });
};

export const getTmsWarehouse = () => {
  return axios.request({
    url: "/endpoint/exception/warehouse",
    method: "get"
  });
};
export const getCycles = () => {
  return axios.request({
    url: "/endpoint/exception/cycles",
    method: "get"
  });
};
export const getStatus = () => {
  return axios.request({
    url: "/endpoint/exception/status",
    method: "get"
  });
};

export const addPickups = data => {
  return axios.request({
    url: "/endpoint/addPickup",
    method: "get",
    data
  });
};
